"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { ArrowRight, Check, Play, Sparkles } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Zonapphero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const todoTasks = [{
    id: 1,
    title: "Rapat Koordinasi Wilayah",
    tag: "Agenda",
    tagColor: "bg-orange-100 text-orange-700",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/avatar_1.png"
  }, {
    id: 2,
    title: "Verifikasi Data Anggota",
    tag: "Admin",
    tagColor: "bg-orange-100 text-orange-700",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/avatar_2.png"
  }];
  const inProgressTasks = [{
    id: 3,
    title: "Penyusunan Program Kerja",
    tag: "Strategi",
    tagColor: "bg-orange-500 text-white",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/avatar_3.png"
  }, {
    id: 4,
    title: "Sosialisasi Konstitusi",
    tag: "Humas",
    tagColor: "bg-orange-500 text-white",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/avatar_4.png"
  }];
  const doneTasks = [{
    id: 5,
    title: "Pelantikan Pengurus Baru",
    tag: "Selesai",
    tagColor: "bg-orange-500 text-white",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/avatar_5.png"
  }];
  const trustItems = ["Terverifikasi Resmi", "Akses 24/7", "Update Real-time"];
  return <section data-section-id="69" id="zonapphero" className="relative w-full overflow-hidden bg-white text-black min-h-[720px] flex items-center">
      {}
      <div aria-hidden="true" className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: "radial-gradient(hsl(0 0% 0%) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} />

      {}
      <div aria-hidden="true" className="absolute -top-40 -right-40 w-[800px] h-[800px] rounded-lg pointer-events-none" style={{
      background: "radial-gradient(circle, hsla(25, 83%, 55%, 0.2) 0%, transparent 60%)",
      filter: "blur(60px)"
    }} />

      {}
      <div aria-hidden="true" className="absolute -bottom-40 -left-40 w-[700px] h-[700px] rounded-lg pointer-events-none" style={{
      background: "radial-gradient(circle, hsla(27, 31%, 22%, 0.1) 0%, transparent 60%)",
      filter: "blur(80px)"
    }} />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-[55fr_45fr] gap-12 lg:gap-20 items-center">
          {}
          <div ref={leftRef} className={`flex flex-col gap-8 transition-all duration-1000 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <Badge variant="outline" className="self-start rounded-lg border-orange-200 bg-orange-50/80 backdrop-blur-sm px-3 py-1.5 text-[13px] font-default text-orange-800">
              <span className="relative flex h-2 w-2 mr-2">
                <span className="absolute inline-flex h-full w-full rounded-lg bg-orange-500 opacity-75 animate-ping" />
                <span className="relative inline-flex rounded-lg h-2 w-2 bg-orange-500" />
              </span>
              ZONA PP · Update Terkini
            </Badge>

            {}
            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-[84px] font-bold leading-[1.02] tracking-tight text-black">
              Portal Informasi Resmi{" "}
              <span className="text-orange-600">
                Pemuda Pancasila.
              </span>
            </h1>

            {}
            <p className="text-lg md:text-xl text-gray-600 max-w-[520px] leading-relaxed font-default">
              ABADI.NEWS menghadirkan informasi terpercaya, mandat organisasi, dan warta kegiatan Pemuda Pancasila di seluruh pelosok negeri.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 mt-2">
              <Link to="/PPZonePage">
                <Button size="lg" className="h-12 px-6 rounded-lg bg-orange-600 text-white hover:bg-orange-700 font-bold text-base shadow-md w-full sm:w-auto">
                  Jelajahi Zona PP
                  <ArrowRight className="ml-1 size-4" />
                </Button>
              </Link>
              <Link to="/LivePage">
                <Button variant="ghost" size="lg" className="h-12 px-5 rounded-lg text-black hover:bg-gray-100 font-medium text-base w-full sm:w-auto">
                  <span className="flex items-center justify-center size-7 rounded-lg bg-gray-100 mr-1">
                    <Play className="size-3 fill-current" />
                  </span>
                  Tonton Live
                </Button>
              </Link>
            </div>

            {}
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-2 font-default text-[13px] text-gray-500">
              {trustItems.map((item, i) => <div data-index={i} key={item} className="flex items-center gap-1.5">
                  <Check className="size-3.5 text-orange-600" strokeWidth={2.5} />
                  <span>{item}</span>
                </div>)}
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative w-full transition-all duration-1000 delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="relative mx-auto w-full max-w-[580px] lg:rotate-[-2deg] origin-center" style={{
            filter: "drop-shadow(0 30px 60px hsla(0, 0%, 0%, 0.1))"
          }}>
              <Card className="bg-white border border-gray-200 rounded-lg overflow-hidden p-0 gap-0">
                {}
                <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 bg-gray-50">
                  <div className="flex items-center gap-2">
                    <div className="flex gap-1.5">
                      <span className="size-2.5 rounded-lg bg-red-600" />
                      <span className="size-2.5 rounded-lg bg-orange-500" />
                      <span className="size-2.5 rounded-lg bg-black" />
                    </div>
                    <span className="ml-3 font-default text-xs text-gray-500">
                      abadi.news / zona-pp
                    </span>
                  </div>
                  <span className="font-default text-xs text-gray-500">PP</span>
                </div>

                <CardContent className="p-4 grid grid-cols-3 gap-3">
                  {}
                  <div className="flex flex-col gap-2.5">
                    <div className="flex items-center justify-between px-1">
                      <span className="font-default text-xs font-bold text-black uppercase tracking-wider">
                        Agenda
                      </span>
                      <span className="font-default text-xs text-gray-400">{todoTasks.length}</span>
                    </div>
                    {todoTasks.map((task, i) => <div data-index={i} key={task.id} className="bg-gray-50 border border-gray-100 rounded-lg p-2.5 flex flex-col gap-2">
                        <p className="text-[11px] text-black leading-snug font-bold">
                          {task.title}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className={`text-[9px] px-1.5 py-0.5 rounded-lg font-default ${task.tagColor}`}>
                            {task.tag}
                          </span>
                          <SafeHydrate><Avatar className="size-5 border border-white">
                            <AvatarImage src={task.avatar} alt="" />
                            <AvatarFallback className="text-[8px]">PP</AvatarFallback>
                          </Avatar></SafeHydrate>
                        </div>
                      </div>)}
                  </div>

                  {}
                  <div className="flex flex-col gap-2.5">
                    <div className="flex items-center justify-between px-1">
                      <span className="font-default text-xs font-bold text-black uppercase tracking-wider">
                        Proses
                      </span>
                      <span className="font-default text-xs text-gray-400">{inProgressTasks.length}</span>
                    </div>
                    {inProgressTasks.map((task, i) => <div data-index={i} key={task.id} className="bg-gray-50 border-l-2 border-l-orange-500 border border-gray-100 rounded-lg p-2.5 flex flex-col gap-2">
                        <p className="text-[11px] text-black leading-snug font-bold">
                          {task.title}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className={`text-[9px] px-1.5 py-0.5 rounded-lg font-default ${task.tagColor}`}>
                            {task.tag}
                          </span>
                          <SafeHydrate><Avatar className="size-5 border border-white">
                            <AvatarImage src={task.avatar} alt="" />
                            <AvatarFallback className="text-[8px]">PP</AvatarFallback>
                          </Avatar></SafeHydrate>
                        </div>
                      </div>)}
                  </div>

                  {}
                  <div className="flex flex-col gap-2.5">
                    <div className="flex items-center justify-between px-1">
                      <span className="font-default text-xs font-bold text-black uppercase tracking-wider">
                        Selesai
                      </span>
                      <span className="font-default text-xs text-gray-400">{doneTasks.length}</span>
                    </div>
                    {doneTasks.map((task, i) => <div data-index={i} key={task.id} className="bg-gray-50 border border-gray-100 rounded-lg p-2.5 flex flex-col gap-2 opacity-80">
                        <p className="text-[11px] text-black leading-snug font-bold line-through decoration-gray-400">
                          {task.title}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className={`text-[9px] px-1.5 py-0.5 rounded-lg font-default ${task.tagColor}`}>
                            <Check className="inline size-2 mr-0.5" strokeWidth={3} />
                            {task.tag}
                          </span>
                          <SafeHydrate><Avatar className="size-5 border border-white">
                            <AvatarImage src={task.avatar} alt="" />
                            <AvatarFallback className="text-[8px]">PP</AvatarFallback>
                          </Avatar></SafeHydrate>
                        </div>
                      </div>)}
                  </div>
                </CardContent>
              </Card>
            </div>

            {}
            <div className="hidden md:block absolute -top-6 -right-2 lg:-right-8 w-[240px] lg:rotate-[4deg] origin-center z-20" style={{
            filter: "drop-shadow(0 20px 40px hsla(0, 0%, 0%, 0.1))"
          }}>
              <Card className="bg-white border border-orange-200 rounded-lg p-0 gap-0">
                <CardContent className="p-3.5">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="flex items-center justify-center size-6 rounded-lg bg-orange-100">
                      <Sparkles className="size-3 text-orange-600" />
                    </div>
                    <span className="font-default text-xs font-bold text-black">
                      Warta Terkini
                    </span>
                  </div>
                  <p className="text-[11px] text-gray-600 leading-relaxed mb-2">
                    Rapat pleno nasional telah menetapkan <span className="text-orange-600 font-bold">3 agenda utama</span> untuk penguatan organisasi.
                  </p>
                  <div className="flex items-center gap-1.5 font-default text-[10px] text-gray-500">
                    <span className="size-1.5 rounded-lg bg-orange-500 animate-pulse" />
                    Baru saja
                  </div>
                </CardContent>
              </Card>
            </div>

            {}
            <div className="hidden md:block absolute -bottom-6 -left-2 lg:-left-10 w-[220px] lg:rotate-[-3deg] origin-center z-20" style={{
            filter: "drop-shadow(0 20px 40px hsla(0, 0%, 0%, 0.1))"
          }}>
              <Card className="bg-white border border-gray-200 rounded-lg p-0 gap-0">
                <CardContent className="p-3.5">
                  <div className="flex items-center justify-between mb-2.5">
                    <span className="font-default text-xs font-bold text-black">
                      Partisipasi
                    </span>
                    <span className="font-default text-[10px] text-orange-600 font-bold">+24%</span>
                  </div>
                  <div className="flex items-end gap-1 h-12">
                    {[40, 55, 35, 65, 50, 75, 90].map((h, i) => <div data-index={i} key={i} className="flex-1 rounded-lg" style={{
                    height: `${h}%`,
                    background: i === 6 ? "#EA580C" : "#E5E7EB"
                  }} />)}
                  </div>
                  <div className="flex justify-between mt-1.5 font-default text-[9px] text-gray-500">
                    <span>Sen</span>
                    <span>Min</span>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}